import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 1rem;
`;

export const PillListWrapper = styled.div`
  align-items: baseline;
  display: flex;
  flex: auto;
`;

export const PillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: auto;
  margin-left: -0.5rem;
  margin-bottom: 0.5rem;

  & > * {
    margin: 0.5rem 0 0 0.5rem;
  }
`;
